export class CategoryWiseTokenConsumptionModel {
    freebieCategory: string;
    tokensConsumed: number;

    /**
     * 
     * @param freebieCategory 
     * @param tokensConsumed 
     */
    constructor(freebieCategory: string, tokensConsumed: number) {
        this.freebieCategory = freebieCategory;
        this.tokensConsumed = tokensConsumed;
    }
}